import { render, staticRenderFns } from "./CreateNewPublicExam.vue?vue&type=template&id=7a105252"
import script from "./CreateNewPublicExam.vue?vue&type=script&lang=js"
export * from "./CreateNewPublicExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports